import CompanyFormModal from "../../_features/company/modals/CompanyFormModal";
import ContactOnlyModal from "../../_features/contacts/modals/ContactOnlyModal";
import MarketFormModal from "../../_features/markets/modals/MarketFormModal";
import UserManagementFormModal from "../../_features/userManagement/modals/UserManagementFormModal";
import BillingUnitFormModal from "../../_features/billingUnits/modals/BillingUnitFormModal";
import UsageSourceFormModal from "../../_features/usageSources/modals/UsageSourceFormModal";
import UsageCompilationFormModal from "../../_features/usageCompilation/modals/UsageCompilationFormModal";
import UpsellFormModal from "../../_features/upsellDownsell/modals/UpsellFormModal";

// UpsellFormModal predates this registry and takes `initialData`, not the
// `rowData` every other panel here standardized on (see
// docs/futurescope/entity-tool-map.md's registry-readiness note) - this
// thin adapter is the only translation needed, so it doesn't need its own
// wizard-body rewrite just to plug in.
const UpsellFormModalAdapter = ({ rowData, ...props }) => (
  <UpsellFormModal {...props} initialData={rowData} />
);

/**
 * Tool-call name -> panel to render. Names match the backend tool-call
 * vocabulary in docs/futurescope/ai-tool-calls-spec.md (simplifyserver) on
 * purpose, so the same names eventually reach an AI tool-call layer without
 * translation.
 *
 * Only entries actually wired up live here - see
 * docs/futurescope/entity-tool-map.md for the full planned inventory.
 * Bundle, Invoice, Subscription, Proposal, and Object customization field
 * are deliberately NOT here yet - their modals don't share this registry's
 * `{isOpen, mode, rowData, onClose, onSuccess}` contract (Bundle edits many
 * records in one table rather than one-record-per-panel; Invoice has no
 * edit mode; Subscription/Proposal require a `customerData` the opener has
 * no generic way to supply) and forcing them in would need a real design
 * decision, not a mechanical wrapper - see the entity-tool-map for the
 * per-entity reasoning.
 *
 * `kind: "route"` entries (Plan, Product, Role, Billing logic) don't belong
 * in this registry at all - they navigate instead of opening a panel, per
 * the navigate-and-resume design in the spec.
 */
export const ENTITY_MODAL_REGISTRY = {
  create_company: { component: CompanyFormModal, mode: "create" },
  update_company: { component: CompanyFormModal, mode: "edit" },
  create_contact: { component: ContactOnlyModal, mode: "create" },
  update_contact: { component: ContactOnlyModal, mode: "edit" },
  create_market: { component: MarketFormModal, mode: "create" },
  update_market: { component: MarketFormModal, mode: "edit" },
  create_user: { component: UserManagementFormModal, mode: "create" },
  update_user: { component: UserManagementFormModal, mode: "edit" },
  create_billing_unit: { component: BillingUnitFormModal, mode: "create" },
  update_billing_unit: { component: BillingUnitFormModal, mode: "edit" },
  create_usage_source: { component: UsageSourceFormModal, mode: "create" },
  update_usage_source: { component: UsageSourceFormModal, mode: "edit" },
  create_usage_compilation: { component: UsageCompilationFormModal, mode: "create" },
  update_usage_compilation: { component: UsageCompilationFormModal, mode: "edit" },
  create_upsell: { component: UpsellFormModalAdapter, mode: "create" },
  update_upsell: { component: UpsellFormModalAdapter, mode: "edit" },
};
